declare namespace $ {

	export class $exso_sheets_shifts_class extends $exso_sheets {
		paths( ): readonly(any)[]
		shift( ): ({ 
			'1': string,
			'2': string,
		}) 
		order_by( ): readonly(any)[]
		columns( ): ({ 
			'value': ({ 
				'title': string,
				'unit': string,
			}) ,
			'fuel': ({ 
				'title': string,
				'unit': string,
			}) ,
			'redrill': ({ 
				'title': string,
				'unit': string,
			}) ,
			'tech_downtime': ({ 
				'title': string,
				'unit': string,
			}) ,
			'org_downtime': ({ 
				'title': string,
				'unit': string,
			}) ,
			'downtime': ({ 
				'title': string,
				'unit': string,
			}) ,
			'fuel__value': ({ 
				'title': string,
				'unit': string,
			}) ,
			'wells_count': ({ 
				'title': string,
				'unit': string,
			}) ,
			'device': ({ 
				'title': string,
			}) ,
			'place': ({ 
				'title': string,
			}) ,
			'date': ({ 
				'title': string,
			}) ,
			'shift': ({ 
				'title': string,
			}) ,
			'supervisor': ({ 
				'title': string,
			}) ,
			'note': ({ 
				'title': string,
			}) ,
			'block': ({ 
				'title': string,
				'type': string,
			}) ,
			'compressor': ({ 
				'title': string,
			}) ,
			'fuel_compressor': ({ 
				'title': string,
				'unit': string,
			}) ,
			'fuel_device': ({ 
				'title': string,
				'unit': string,
			}) ,
			'hours_device': ({ 
				'title': string,
				'unit': string,
			}) ,
			'hours_compressor': ({ 
				'title': string,
				'unit': string,
			}) ,
		}) 
	}
	
}

//# sourceMappingURL=shifts.view.tree.d.ts.map